export const getNextLoopOccurrence = (loopMetadata, currentTask) => {
  if (loopMetadata?.task_type !== "loop") return null;

  // Check if we hit the limit
  const maxOccurrences = Number(loopMetadata?.repeat_occurrences || 0);
  const hasLimit = maxOccurrences > 0 && !loopMetadata?.create_next_after_completion;
  
  if (hasLimit) {
    const currentIndex = currentTask?.occurrence_index !== undefined ? currentTask.occurrence_index : 0;
    if (currentIndex + 1 >= maxOccurrences) return "No future occurrences";
  }

  const baseDate = currentTask?.occurrence_date || currentTask?.start_date || new Date().toISOString().slice(0, 10);
  const every = Number(loopMetadata?.repeat_every || 1);
  const frequency = loopMetadata?.repeat_frequency || "Daily";

  const date = new Date(`${baseDate}T00:00:00`);
  
  if (frequency === "Daily") {
    date.setDate(date.getDate() + every);
  } else if (frequency === "Weekly") {
    date.setDate(date.getDate() + every * 7);
  } else if (frequency === "Monthly" || frequency === "Monthly by Date") {
    date.setMonth(date.getMonth() + every);
  } else if (frequency === "Yearly") {
    date.setFullYear(date.getFullYear() + every);
  }

  if (loopMetadata?.repeat_end_date) {
    if (date > new Date(`${loopMetadata.repeat_end_date}T00:00:00`)) return "No future occurrences";
  }

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const isScheduledOccurrence = (task) => {
  return task?.is_preview === true;
};

export const isActiveGeneratedOccurrence = (task) => {
  return task?.is_loop_occurrence === true && !task?.is_preview;
};
